export enum ProcedenciaType {
    Comerciales= 'comercial',
    Clientes= 'cuenta',
    Empleados = 'empleado',
    Colaboradores = 'colaborador',
    BNI = 'bni',
    Campanhas = 'publicidad',
}
